/* istanbul ignore file */

import { defineMessages, type MessageValue, type NoMessageValues } from 'react-intl';

// ─────────────────────────────────────────────────────────────────────────────

export const messages = defineMessages<{
  readonly title: NoMessageValues;
  readonly description: { readonly scope: MessageValue };
  readonly learnMoreLabel: NoMessageValues;
  readonly switchAccountLabel: NoMessageValues;
  readonly cancelledMessage: NoMessageValues;
  readonly notVerifiedMessage: NoMessageValues;
  readonly failedMessage: NoMessageValues;
  readonly verifiedMessage: { readonly groups: MessageValue };
  readonly verifiedMultipleGroupsMessage: { readonly groups: MessageValue };
  readonly partnerLogoAlt: NoMessageValues;
}>({
  title: {
    defaultMessage: 'Verify your ID.me account',
    description: 'ID.me | Fallbacks | Screen title',
  },
  description: {
    defaultMessage:
      'Confirm your {scope} status. You will sign in with ID.me and will be directed back here.',
    description: 'ID.me | Fallbacks | Description before verifying',
  },
  learnMoreLabel: {
    defaultMessage: 'Learn more',
    description: 'ID.me | Fallbacks | Learn more button',
  },
  switchAccountLabel: {
    defaultMessage: 'Use a different ID.me account',
    description:
      'ID.me | Fallbacks | Sign out of ID.me so the next attempt can use another account',
  },
  cancelledMessage: {
    defaultMessage: 'Nothing was shared with us. You can try again whenever you are ready.',
    description: 'ID.me | Fallbacks | Cancelled notice',
  },
  notVerifiedMessage: {
    defaultMessage: 'ID.me did not find a status matching this offer on your account.',
    description: 'ID.me | Fallbacks | Not verified notice',
  },
  failedMessage: {
    defaultMessage: 'Something went wrong while verifying. Please try again.',
    description: 'ID.me | Fallbacks | Failed verification notice',
  },
  verifiedMessage: {
    defaultMessage: 'ID.me has confirmed that you are in the {groups} group.',
    description: 'ID.me | Fallbacks | Verified message for one group',
  },
  verifiedMultipleGroupsMessage: {
    defaultMessage: 'ID.me has confirmed that you are in these groups: {groups}.',
    description: 'ID.me | Fallbacks | Verified message for several groups',
  },
  partnerLogoAlt: {
    defaultMessage: 'Campaign partner logo',
    description: 'ID.me | Fallbacks | Partner logo alt text',
  },
});

export const groupNameMessages = defineMessages({
  military: {
    defaultMessage: 'Military',
    description: 'ID.me | Fallbacks | Group names | Military',
  },
  responder: {
    defaultMessage: 'First Responder',
    description: 'ID.me | Fallbacks | Group names | First responder',
  },
  student: {
    defaultMessage: 'Student',
    description: 'ID.me | Fallbacks | Group names | Student',
  },
  teacher: {
    defaultMessage: 'Teacher',
    description: 'ID.me | Fallbacks | Group names | Teacher',
  },
  government: {
    defaultMessage: 'Government',
    description: 'ID.me | Fallbacks | Group names | Government employee',
  },
  employee: {
    defaultMessage: 'Employee',
    description: 'ID.me | Fallbacks | Group names | Employee',
  },
  hospitalEmployee: {
    defaultMessage: 'Hospital Employee',
    description: 'ID.me | Fallbacks | Group names | Hospital employee',
  },
  alumni: {
    defaultMessage: 'Alumni',
    description: 'ID.me | Fallbacks | Group names | Alumni',
  },
  nurse: {
    defaultMessage: 'Nurse',
    description: 'ID.me | Fallbacks | Group names | Nurse',
  },
  medical: {
    defaultMessage: 'Medical Provider',
    description: 'ID.me | Fallbacks | Group names | Medical provider',
  },
});
